import BigNumber from 'bignumber.js'
import erc20ABI from 'config/abi/erc20.json'
import masterchefABI from 'config/abi/masterchef.json'
import multicall from 'utils/multicall'
import fetchPendingToon from 'utils/pendingToon'
import farmsConfig from 'config/constants/farms'
import { getAddress, getMasterChefAddress } from 'utils/addressHelpers'
import { getWeb3NoAccount } from 'utils/web3'

export const fetchFarmUserAllowances = async (account: string) => {
  const masterChefAdress = getMasterChefAddress()

  const calls = farmsConfig.map((farm) => {
    const lpContractAddress = getAddress(farm.lpAddresses)
    return { address: lpContractAddress, name: 'allowance', params: [account, masterChefAdress] }
  })

  const rawLpAllowances = await multicall(erc20ABI, calls)
  const parsedLpAllowances = rawLpAllowances.map((lpBalance) => {
    return new BigNumber(lpBalance).toJSON()
  })
  return parsedLpAllowances
}

export const fetchFarmUserTokenBalances = async (account: string) => {
  const calls = farmsConfig.map((farm) => {
    const lpContractAddress = getAddress(farm.lpAddresses)
    return {
      address: lpContractAddress,
      name: 'balanceOf',
      params: [account],
    }
  })

  const rawTokenBalances = await multicall(erc20ABI, calls)
  const parsedTokenBalances = rawTokenBalances.map((tokenBalance) => {
    return new BigNumber(tokenBalance).toJSON()
  })
  return parsedTokenBalances
}

export const fetchFarmUserStakedBalances = async (account: string) => {
  const masterChefAdress = getMasterChefAddress()
  const web3 = getWeb3NoAccount()
  const masterChefContract = new web3.eth.Contract(masterchefABI as any, masterChefAdress)

  const parsedStakedBalances = await Promise.all(
    farmsConfig.map(async (farm) => {
      try {
        const stakedBalance = await masterChefContract.methods.userInfo(farm.pid, account).call()
        const amount = stakedBalance?.amount ?? stakedBalance?.[0] ?? '0'
        return new BigNumber(amount).toJSON()
      } catch (error) {
        console.warn(`Failed to fetch userInfo for pid ${farm.pid}`, error)
        return '0'
      }
    }),
  )

  return parsedStakedBalances
}

export const fetchFarmUserEarnings = async (account: string) => {
  const earnings = await fetchPendingToon(
    farmsConfig.map((farm) => farm.pid),
    account,
  )
  return earnings.map((earning) => earning.toJSON())
}
